import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

import qs from 'qs';

import Spinner from 'components/Spinner';
import { RenderBankLogoName } from 'components/RenderBankPaymentMethod';
import FormDirectDebitBTN from 'components/FormDirectDebit/FormDirectDebitBTN';

import { post } from 'network/api';
import { ItemPayment, SettingsProps, PaymentResultData } from 'pages/types';

interface PaymentMethodType {
  data: ItemPayment[];
  settings: SettingsProps;
  setDataPayment: (value: PaymentResultData) => void;
  setPickPayment: (value: boolean) => void;
}

const MethodEWallet: React.FC<PaymentMethodType> = ({
  data,
  settings,
  setDataPayment,
  setPickPayment,
}) => {
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { id } = query as { id?: string };
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [paymentType, setPaymentType] = useState<ItemPayment | undefined>();

  const [accountCC, setAccountCC] = useState<string>('');
  const [pickDirectDebitBank, setPickDirectDebitBank] = useState<
    ItemPayment | undefined
  >();

  const onPickPayment = (paymentType: ItemPayment | undefined) => {
    if (!paymentType) {
      toast.error('Payment type is not selected!');
      return;
    }

    setPickDirectDebitBank(paymentType);
  };

  const handleOnSubmit = async (
    paymentType: ItemPayment | undefined,
    id: string
  ) => {
    if (!paymentType) {
      toast.error('Payment type is not selected!');
      return;
    }

    const payload = {
      type: paymentType.type ? paymentType.type : '',
      service_id: paymentType.service_id ? paymentType.service_id : '',
      customer_no: '4508750015741019',
      payment_method_id: paymentType.id ? paymentType.id : 0,
    };

    await post(`/checkout/v1/payment-method?invoice_number=${id}`, payload)
      .then((res) => {
        const { data } = res;
        setLoadingSubmit(false);
        setPickPayment(true);
        setDataPayment({
          type: data.type ? data?.type : '-',
          bank: data.bank_info ? data?.bank_info?.bank_name : '-',
          va_number: data.bank_info ? data?.bank_info?.account_number : '-',
          account_name: data.virtual_account_name
            ? data?.virtual_account_name
            : '-',
          qr_content: data.qr_content ? data?.qr_content : '-',
          host_to_host_payment_info: data.h2h_payment_info || {
            web_redirect_url: undefined,
          },
        });

        if (data.h2h_payment_info.web_redirect_url) {
          if (data.h2h_payment_info.web_redirect_url.startsWith('http')) {
            window.open(data.h2h_payment_info.web_redirect_url, '_blank');
          } else {
            window.location.href = data.h2h_payment_info.web_redirect_url;
          }
        }
      })
      .catch((err) => {
        toast.error(err.detail);
        setLoadingSubmit(false);
      });
  };

  if (pickDirectDebitBank?.code === 'DD') {
    return (
      <div className="mt-3">
        <div
          className="border rounded-md p-3"
          style={{
            borderColor: settings.button_color,
            backgroundColor: settings.primary_color,
          }}
        >
          <FormDirectDebitBTN
            items={pickDirectDebitBank}
            active={true}
            settings={settings}
            accountCC={accountCC}
            setAccountCC={setAccountCC}
            setDataPayment={setDataPayment}
            setPickPayment={setPickPayment}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2 py-3">
      {data.map((items) => {
        const active = paymentType?.id === items.id;
        return (
          <div className="flex flex-col gap-2" key={items.id}>
            <label
              htmlFor={items.code}
              className={`border rounded-md p-3 ${
                !active ? '!border-gray-300 !bg-white' : ''
              }`}
              style={{
                borderColor: settings.button_color,
                backgroundColor: settings.primary_color,
              }}
            >
              <div className="flex flex-row justify-between items-center">
                <RenderBankLogoName
                  title={items.code}
                  key={items.id}
                  idx={items.id}
                  name={items.name}
                />
                <div className="flex flex-row gap-2 items-center">
                  <input
                    id={items.code}
                    name={items.code}
                    type="checkbox"
                    aria-describedby={`${items.code}-description`}
                    className="h-4 w-4 rounded-full border-gray-300 focus:ring-primary-light"
                    checked={active}
                    onChange={() => setPaymentType(items)}
                    style={{
                      color: settings.button_color,
                    }}
                  />
                </div>
              </div>
            </label>
          </div>
        );
      })}

      <button
        style={{
          backgroundColor: settings.button_color,
          color: settings.button_text_color,
        }}
        disabled={loadingSubmit}
        onClick={() =>
          paymentType?.type === 'cards'
            ? handleOnSubmit(paymentType, id || '')
            : onPickPayment(paymentType)
        }
        className={`mt-4 w-full flex flex-row items-center gap-2 justify-center rounded-md border border-transparent ${
          loadingSubmit ? 'bg-gray-200 hover:bg-gray-400' : ''
        } px-4 py-2.5 text-base font-medium text-white shadow-sm  focus:outline-none`}
      >
        {paymentType?.type !== 'cards' ? (
          'CHOOSE'
        ) : loadingSubmit ? (
          <Spinner />
        ) : (
          'PAY'
        )}
      </button>
    </div>
  );
};

export default MethodEWallet;
